import React, { Component } from 'react'
import { FRONTEND_URL } from '../config'

class CloneAppFooter extends Component {
  render() {
    const { app } = this.props

    if (!app) return null

    let cloneURL = `${FRONTEND_URL}/apps/${app.id}/screens/${app.visibility}`

    return (
      <React.Fragment>
        {app && (
          <React.Fragment>
            {app.visibility ? (
              <div className="web-runtime-footer">
                <div>
                  {app.visibility && (
                    <div className="details-clone-button-wrapper">
                      <a className="details-clone-button" href={cloneURL}>
                        Clone App
                      </a>
                    </div>
                  )}
                </div>
                <a
                  href="https://adalo.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="preview-proton-attribution"
                >
                  <span className="logo" alt="Adalo" />
                  <h6>Created with Adalo</h6>
                </a>
              </div>
            ) : null}
          </React.Fragment>
        )}
      </React.Fragment>
    )
  }
}

export default CloneAppFooter
